import fileDownload from 'js-file-download';
import moment from 'moment'


export const isIterableArray = (arr: Array<any | undefined> | undefined) => Array.isArray(arr) && !!arr.length;

export const toFormatPrice = (price: number | undefined, fixedLength: number = 2) => {

    if (price === 0) return '0,00'
    if (!price) return price

    const trunc = Math.trunc(price) // целая часть 
    const decimal = Math.abs(price - trunc) // модуль дробной части
    const trunc_format = trunc.toLocaleString('ru-RU')  // целая часть в формате с отступами

    let decimal_format
    if (fixedLength) decimal_format = decimal.toFixed(fixedLength).replace('0.', ',') // дробная часть в формате с 2 знаками после запятой
    else decimal_format = String(decimal).replace('0.', ',')

    return trunc_format + decimal_format
}
export const toStringPrice = (price: any) => {
    if (!price) return price
    return price.toLocaleString('ru-RU', {
        maximumSignificantDigits: 20
    })
}

export const toTableDate = (date: string) => {

    // const { t } = useTranslation()
    const serverFormat = 'yyyy-mm'
    const month = moment(date, serverFormat).format('mm')
    const year = moment(date, serverFormat).format('YY')

    const monthText = `short_month_${month}`

    return monthText + ' - ' + year
}

export const toDate = (date: string, formatIn: string = 'YYYY-MM-DD', formatOut: string = 'DD.MM.YYYY') => {
    const dateText = moment(date, formatIn).format(formatOut)
    return dateText
}

export const numWord = (val: number) => {
    const value = Math.abs(val) % 100;
    const num: number = value % 10;
    if (value > 10 && value < 20) return 3; // (-ов)
    if (num > 1 && num < 5) return 2; // (-a)
    if (num === 1) return 1; // (-)
    return 3; // (-ов)
}

// replace string for search function
export const replacedString = (str: string) => {
    if (str) {
        return str.replaceAll(' ', '').replaceAll('.', '').replaceAll(',', '')
    }
    else return ''
}

export const blobToBase64 = (blob: any) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise(resolve => {
        reader.onloadend = () => {
            resolve(reader.result);
        };
    });
};

export const saveGraphToPicture = (elId: string, filename: string) => {
    const canvasSave: any = document.getElementById(elId);
    if (canvasSave) {
        canvasSave.toBlob(function (blob: any) {
            fileDownload(blob, filename)
        })
    }
}

export const save2picture = (elId1: string, elId2: string, filename1: string, filename2: string, filenameCommon: string) => {
    const canvasSave1: any = document.getElementById(elId1);
    const canvasSave2: any = document.getElementById(elId2);
    if (canvasSave1 && !canvasSave2) {
        canvasSave1.toBlob(function (blob: any) {
            fileDownload(blob, filename1)
        })
        return
    }
    if (!canvasSave1 && canvasSave2) {
        canvasSave2.toBlob(function (blob: any) {
            fileDownload(blob, filename2)
        })
        return
    }
    if (canvasSave1 && canvasSave2) {

        const width = 673
        const height = 673

        const c: any = document.getElementById("save2pictureCanvas");
        const ctx = c.getContext("2d");

        ctx.canvas.width = (width * 2) + 45;
        ctx.canvas.height = height + 30;

        const imageObj1 = new Image();
        const imageObj2 = new Image();
        canvasSave1.toBlob(function (blob: any) {
            const src = URL.createObjectURL(blob)
            imageObj1.src = src
        })

        imageObj1.onload = function () {
            ctx.drawImage(imageObj1, 15, 15, width, height);
            canvasSave2.toBlob(function (blob: any) {
                const src = URL.createObjectURL(blob)
                imageObj2.src = src
            })
            imageObj2.onload = function () {
                ctx.drawImage(imageObj2, width + 30, 15, width, height);

                ctx.save();
                ctx.globalCompositeOperation = 'destination-over';
                ctx.fillStyle = '#fdfdfd';
                ctx.fillRect(0, 0, c.width, c.height);

                c.toBlob(function (blob: any) {
                    fileDownload(blob, filenameCommon)
                })
            }
        };
    }
}

export const pluginDoughnutBg = {
    id: 'customCanvasBackgroundColor',
    beforeDraw: (chart: any) => {
        const { ctx } = chart;
        ctx.save();
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle = '#fdfdfd';
        ctx.fillRect(0, 0, chart.width, chart.height);
        ctx.restore();
    }
};
export const pluginBg = {
    id: 'background',
    beforeDraw: (chart: any) => {
        const {
            ctx,
            chartArea
        } = chart;
        ctx.save()
        const { top, left, height, width, bottom } = chartArea
        // ctx.fillStyle = 'red';
        ctx.fillStyle = '#fdfdfd';
        ctx.fillRect(left - 30, top - 30, width + 60, bottom * 3)
    }
}

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const isValidEmail = (email: string) => emailRegex.test(email.trim())